module.exports = __webpack_public_path__ + "img/schedule4.b13de8d1.png";